export const c_pagination_m_display_full__total_items_Display = {
  "name": "--pf-c-pagination--m-display-full__total-items--Display",
  "value": "none",
  "var": "var(--pf-c-pagination--m-display-full__total-items--Display)"
};
export default c_pagination_m_display_full__total_items_Display;